module.exports = __webpack_public_path__ + "static/media/531573_557056637661928_597147559_n.534f34db.jpg";